import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { WidgetParent } from "../../class/widget-parent";
import { ComponentAdapterFactory } from "../../class/adapters/component-adapter-factory";
import { ComponentAdaperContact } from "../../class/adapters/component-adapter-contact";
import { SmartPaletteGeneral } from "../../class/smart-palette";

@Component({
    selector: "app-widget-contact",
    templateUrl: "./widget-contact.component.html",
    styleUrls: ["./widget-contact.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class WidgetContactComponent extends WidgetParent<ComponentAdaperContact> {
  /**
   * Handle the click on the contact switch
   */
  public onClickContactSwitch(): void {
    if (this.componentAdapter.ContactCommand !== null) {
      const instanceGUID: string =
        this.componentAdapter.ContactCommand.instanceGUID;
      const address: string = this.componentAdapter.ContactCommand.address;

      // Send command to turn on/off the light using VALUE NOT command
      this.sendAddressCommand(instanceGUID, address, "VALUE NOT");
    }
  }

  protected setWidgetSmartPalette(): SmartPaletteGeneral {
    let widgetSmaertPalette = new SmartPaletteGeneral();

    return widgetSmaertPalette;
  }

  protected onComponentLoad(): void {}

  protected onComponentDestroy(): void {}

  protected onSmartComponentErrorLoading(): void {}

  protected onSmartComponentSuccessLoaded(): void {
    const factory = new ComponentAdapterFactory();
    this.componentAdapter = factory.createComponentAdapter(
      this._listSmartComponentSkills,
      ComponentAdaperContact
    );

    this.titleWidget = this.componentAdapter.Name;
  }

  protected onAddressValueChange(
    instanceGUID: string,
    address: string,
    value: string
  ): void {}
}
